import {Collapse, Grid} from "@mui/material";
import {useState, useCallback, memo} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {sliceChoices, unitChoices} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdRadioButton from "../../atomicComponents/MhdRadioButton";
import MhdColorbarWidget from "../../atomicComponents/MhdColorbarWidget";
import WidgetDivider from "../../atomicComponents/WidgetDivider";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";

const SliceWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customizeStyle, setCustomizeStyle] = useState(false)

  return (
    <Grid container>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="CUSTOMIZE STYLE"
            value={customizeStyle}
            onChange={setCustomizeStyle}
        >
          <Collapse in={customizeStyle} >
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={12}>
                <MhdColorbarWidget
                  label="Color Palette"
                  value={data.color}
                  onChange={useCallback((v) => setAndUpdate("color", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdSelect
                  label="Units"
                  value={data.units}
                  onChange={useCallback((v) => setAndUpdate("units", v, setter, update), [])}
                  choices={unitChoices}
                />
              </Grid>
              <Grid item xs={3} />
              <Grid item xs={5}>
                <WidgetSwitch
                  label="Show Text"
                  value={data.show_text}
                  onChange={useCallback((v) => setAndUpdate("show_text", v, setter, update), [])}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}

export default memo(SliceWidget);